// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  position: sticky;
  top: 0;
  z-index: 20;
  box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
}

.mainHeader__WaXzR {
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 15px;
  padding: 10px 25px;
  background-color: var(--header-surface);
  border-bottom: 1px solid var(--header-stroke);
}

.headerLeft__U9Uss {
  display: flex;
  align-items: center;
  column-gap: 20px;
}
@media (max-width: 950px) {
  .headerLeft__U9Uss {
    column-gap: 15px;
  }
}

.headerRight__83o0h {
  display: flex;
  align-items: center;
  column-gap: 15px;
}

.headerTitle__m6k9o {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  color: var(--header-title-main);
  text-transform: uppercase;
}

.headerLeftInfo__XTtN4:not(:empty) {
  height: 35px;
  display: flex;
  align-items: center;
  column-gap: 10px;
  padding: 0 10px;
  background-color: var(--header-elevation);
  border-radius: 2px;
}
.headerLeftInfo__XTtN4:not(:empty):empty {
  display: none;
}

.logoLink__mnTrh {
  height: 35px;
}

.separator__HGWsZ {
  height: 35px;
  width: 1px;
  background-color: var(--header-stroke);
}

.logoImg__uaIlU {
  width: 100%;
  height: 35px;
  object-fit: contain;
}

.facilitySelectBlock__athBR {
  display: flex;
  align-items: center;
  padding-left: 10px;
}

.facilitySelectLabel__qADAj {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--header-title-secondary);
  text-transform: uppercase;
}

.extraBlock__MT3hS {
  width: 100%;
  height: 45px;
  padding: 10px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 25px;
  background-color: var(--header-surface);
  filter: drop-shadow(0px 3px 8px rgba(50, 50, 71, 0.05)) drop-shadow(0px 0px 1px rgba(12, 26, 75, 0.24));
}

.backIcon__T89LY {
  cursor: pointer;
}
.backIcon__T89LY path {
  stroke: var(--header-icon-main);
}`, "",{"version":3,"sources":["webpack://./../src/components/common/Header/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,2FACE;AA1EJ;;AA8EA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;EACA,6CAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA3EF;AA6EE;EALF;IAMI,gBAAA;EA1EF;AACF;;AA6EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;AA1EF;;AA6EA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;EACA,kBAAA;AA1EF;AA4EE;EACE,aAAA;AA1EJ;;AA8EA;EACE,YAAA;AA3EF;;AA8EA;EACE,YAAA;EACA,UAAA;EACA,sCAAA;AA3EF;;AA8EA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AA3EF;;AA8EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;AA3EF;;AA8EA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;EACA,uGAAA;AA3EF;;AA8EA;EACE,eAAA;AA3EF;AA6EE;EACE,+BAAA;AA3EJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\nheader {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  box-shadow:\n    0px 0px 1px 0px rgba(12, 26, 75, 0.24),\n    0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n}\n\n.mainHeader {\n  height: 55px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: 15px;\n  padding: 10px 25px;\n  background-color: var(--header-surface);\n  border-bottom: 1px solid var(--header-stroke);\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  column-gap: 20px;\n\n  @media (max-width: 950px) {\n    column-gap: 15px;\n  }\n}\n\n.headerRight {\n  display: flex;\n  align-items: center;\n  column-gap: 15px;\n}\n\n.headerTitle {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  color: var(--header-title-main);\n  text-transform: uppercase;\n}\n\n.headerLeftInfo:not(:empty) {\n  height: 35px;\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n  padding: 0 10px;\n  background-color: var(--header-elevation);\n  border-radius: 2px;\n\n  &:empty {\n    display: none;\n  }\n}\n\n.logoLink {\n  height: 35px;\n}\n\n.separator {\n  height: 35px;\n  width: 1px;\n  background-color: var(--header-stroke);\n}\n\n.logoImg {\n  width: 100%;\n  height: 35px;\n  object-fit: contain;\n}\n\n.facilitySelectBlock {\n  display: flex;\n  align-items: center;\n  padding-left: 10px;\n}\n\n.facilitySelectLabel {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--header-title-secondary);\n  text-transform: uppercase;\n}\n\n.extraBlock {\n  width: 100%;\n  height: 45px;\n  padding: 10px 25px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: 25px;\n  background-color: var(--header-surface);\n  filter: drop-shadow(0px 3px 8px rgba(50, 50, 71, 0.05)) drop-shadow(0px 0px 1px rgba(12, 26, 75, 0.24));\n}\n\n.backIcon {\n  cursor: pointer;\n\n  path {\n    stroke: var(--header-icon-main);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainHeader": `mainHeader__WaXzR`,
	"headerLeft": `headerLeft__U9Uss`,
	"headerRight": `headerRight__83o0h`,
	"headerTitle": `headerTitle__m6k9o`,
	"headerLeftInfo": `headerLeftInfo__XTtN4`,
	"logoLink": `logoLink__mnTrh`,
	"separator": `separator__HGWsZ`,
	"logoImg": `logoImg__uaIlU`,
	"facilitySelectBlock": `facilitySelectBlock__athBR`,
	"facilitySelectLabel": `facilitySelectLabel__qADAj`,
	"extraBlock": `extraBlock__MT3hS`,
	"backIcon": `backIcon__T89LY`
};
module.exports = ___CSS_LOADER_EXPORT___;
